/**
 *
 */
(function(window, undefined) {
    'use strict';
    const Run = function(
        $http,
        $q,
        $stateParams,
        $timeout,
        userSrvc,
        messaggiFctr,
        labelSrvc,
        loggerSrvc,
        CONSTANTS
    ) {
        this.userSrvcDefer = $q.defer();
        this.labelSrvcDefer = $q.defer();
        userSrvc.abilitazioniPronte = this.userSrvcDefer.promise;
        labelSrvc.labelsPronte = this.labelSrvcDefer.promise;

        this.runned = false;

        this.run = () => {
            if (this.runned) {
                return $q.when(true);
            }

            const defer = $q.defer();
            startLabelsPromise();
            startLoggerPromise();
            startUserPromise();
            this.runned = true;
            $q.all({
                labelSrvcDefer: this.labelSrvcDefer
            }).then(
                (response) => {
                    defer.resolve(response);
                },
                (reason) => {
                    this.runned = false;
                    defer.reject(reason);
                }
            );
            return defer.promise;
        };

        /***
         *
         * @return {*}
         */
        const startLabelsPromise = () => {
            $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LABEL
            }).then(
                (response) => {
                    if (messaggiFctr.processaResponse(response)) {
                        this.labelSrvcDefer.reject(response);
                        return;
                    }
                    labelSrvc.labels = response.data.result;
                    this.labelSrvcDefer.resolve(true);
                },
                (reason) => {
                    messaggiFctr.processaResponse(reason);
                    this.labelSrvcDefer.reject(reason);
                }
            );

            return this.labelSrvcDefer.promise;
        };

        /***
         *
         * @return {*}
         */
        const startUserPromise = () => {
            $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.USER
            }).then(
                (response) => {
                    if (messaggiFctr.processaResponse(response)) {
                        this.userSrvcDefer.reject(response);
                        return;
                    }
                    const userResult = response.data.result;
                    userSrvc.cabelUser = userResult.cabelUser;
                    userSrvc.user = userResult.profile;
                    userSrvc.abilitazioni = userResult.abilitazioni;
                    userSrvc.parametri = userResult.parametri;
                    userSrvc.parametriInstallazione = userResult.parametriInstallazione;
                    this.userSrvcDefer.resolve(true);
                },
                (reason) => {
                    messaggiFctr.processaResponse(reason);
                    this.userSrvcDefer.reject(reason);
                }
            );

            return this.userSrvcDefer.promise;
        };

        const startLoggerPromise = function() {
            $http({
                method: 'GET',
                url: CONSTANTS.REST_ROOT + CONSTANTS.REST.GENERAL.LOG
            }).then(
                function(response) {
                    if (messaggiFctr.processaResponse(response)) {
                        return;
                    }
                    loggerSrvc.setupLogger(response.data.result);
                    // FIXME: riabilitare per gestire correttamente i permessi
                    labelSrvc.develop = loggerSrvc.levelEnabled(loggerSrvc.FINE);
                },
                function(reason) {
                    messaggiFctr.processaResponse(reason);
                }
            );
        };
    };

    Run.$inject = [
        '$http',
        '$q',
        '$stateParams',
        '$timeout',
        'MitomUserSrvc',
        'MitomMessaggiFctr',
        'MitomLabelSrvc',
        'MitomLoggerSrvc',
        'Mitom_CONSTANTS'
    ];
    angular.module('cbl.mitomanager.wa').service('MitomRunService', Run);
})(window);